import { useState, useContext, FC } from 'react';

import { layoutContext } from '@context/layout';
import { useUser } from '@context/user-context';
import useNode from '@hooks/use-node';

import { getName } from '@modules/card-helpers';

import { WorkspaceButton } from './WorkspaceButton';
import { WorkspacePopover } from './WorkspacePopover';
import { NavHeaderTopSection } from './NavHeaderTopSection';
import { ProgressChecklistContext } from '@context/progress-checklist-context';
import { ProgressChecklist } from './ProgressCheckList';

import styles from './NavHeader.module.scss';
import { useActorPlan } from '@hooks/actor/use-actor-plan';

interface NavHeaderProps {
  openUpgradeDialog: () => void;
}

const NavHeader: FC<React.PropsWithChildren<NavHeaderProps>> = ({ openUpgradeDialog }) => {
  const { state: navState } = useContext(layoutContext);
  const { show: showProgressChecklist, steps: checklistSteps } = useContext(ProgressChecklistContext);

  const [workspaceBtnNode, setButtonNode] = useNode<HTMLButtonElement>();
  const [showWorkspacePopover, setShowWorkspacePopover] = useState(false);
  const { planType } = useActorPlan();

  const userDetails = useUser();
  const { user, org } = userDetails;

  const workspaceName = (planType === 'team' && org?.name) || (user && getName(user)) || 'My Workspace';
  const workspaceImage = org?.avatarUrl;

  return (
    <div className={styles['nav-header']} data-collapsed={navState.collapsed}>
      <NavHeaderTopSection />

      <WorkspaceButton
        onClick={() => setShowWorkspacePopover(!showWorkspacePopover)}
        setButtonNode={setButtonNode}
        workspaceName={workspaceName}
        workspaceImage={workspaceImage || null}
      />

      {!navState.collapsed && showProgressChecklist && (
        <div className={styles['onboarding-checklist-container']}>
          <h4 className={styles['onboarding-checklist-title']}>Onboarding checklist</h4>
          <ProgressChecklist steps={checklistSteps} />
        </div>
      )}

      <WorkspacePopover
        show={showWorkspacePopover}
        workspaceName={workspaceName}
        onClose={() => setShowWorkspacePopover(false)}
        targetNode={workspaceBtnNode}
        openUpgradeDialog={openUpgradeDialog}
      />
    </div>
  );
};

export { NavHeader };
